import { useEffect, useState, useRef } from 'react';
import styles from './Notification.module.scss';
import { ReactComponent as ErrorIcon } from '@/assets/Icons/rederror.svg';

import { ReactComponent as SuccessIcon } from '@/assets/Icons/succsess.svg';
import { ReactComponent as WarningIcon } from '@/assets/Icons/warning.svg';

import { useNotificationStore } from '../../store/NotificationStore';

import { Reward } from '../Reward/Reward';

import WebApp from '@twa-dev/sdk';

const Notification = () => {
  const [visible, setVisible] = useState(false);
  const [progress, setProgress] = useState(100);
  const progressRef = useRef<HTMLDivElement>(null);

  const message = useNotificationStore((state) => state.notification.message);
  const type = useNotificationStore((state) => state.notification.type);
  const rewards = useNotificationStore((state) => state.notification.rewards);
  const duration = useNotificationStore((state) => state.notification.duration);
  const closeNotification = useNotificationStore(
    (state) => state.closeNotification,
  );
  const showNotification = useNotificationStore(
    (state) => state.showNotification,
  );
  WebApp;

  useEffect(() => {
    if (WebApp && WebApp.HapticFeedback && message) {
      if (type === 'Error') {
        WebApp.HapticFeedback.notificationOccurred('error');
      } else if (type === 'Warning') {
        WebApp.HapticFeedback.notificationOccurred('warning');
      } else {
        WebApp.HapticFeedback.notificationOccurred('success');
      }
    } else {
      console.warn('Telegram WebApp or HapticFeedback is not available');
    }
  }, [type]);

  useEffect(() => {
    if (showNotification) {
      setVisible(true);
      setProgress(100);

      // Запускаем анимацию прогресса
      const startTime = Date.now();
      const animationDuration = duration || 3000; // Используем кастомную длительность или 3 секунды по умолчанию

      const updateProgress = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(1, elapsed / animationDuration);

        // Равномерная анимация
        const newProgress = Math.max(0, 100 - progress * 100);

        setProgress(newProgress);

        if (progress < 1) {
          requestAnimationFrame(updateProgress);
        }
      };

      requestAnimationFrame(updateProgress);
    } else if (!showNotification && visible) {
      const timer = setTimeout(() => {
        setVisible(false);
      }, 500); // Длительность анимации исчезновения
      return () => clearTimeout(timer);
    }
  }, [showNotification, visible]);

  // Группируем награды по типу и преобразуем в числа
  const heartsReward =
    rewards?.find((reward) => reward.type === 'hearts')?.amount || 0;

  // Обновляю логику применения классов анимации
  const notificationClass = `${styles.notification}`;

  return (
    showNotification && (
      <div className={notificationClass}>
        <div className={styles.containerWrapper}>
          <div
            className={
              type === 'Error'
                ? styles.blurCircleError
                : type === 'Warning'
                  ? styles.blurCircleWarning
                  : styles.blurCircleSuccess
            }
          ></div>
          <div className={styles.icon}>
            {type === 'Error' ? (
              <ErrorIcon />
            ) : type === 'Warning' ? (
              <WarningIcon />
            ) : (
              <SuccessIcon />
            )}
          </div>
          <div className={styles.message}>
            <div
              className={
                type === 'Error'
                  ? styles.errorText
                  : type === 'Warning'
                    ? styles.warningText
                    : styles.successText
              }
            >
              {message}
            </div>
            {rewards && (
              <div className={styles.reward}>
                {rewards.map((reward) => (
                  <Reward
                    type={reward.type as 'stars'}
                    amount={reward.amount}
                  />
                ))}
              </div>
            )}
            {type === 'Success' && rewards && (
              <div className={styles.rewards}>
                {heartsReward > 0 && (
                  <Reward type="hearts" amount={Number(heartsReward)} />
                )}
              </div>
            )}
          </div>
          <div
            onClick={() => {
              console.log('clicked');
              closeNotification();
            }}
            className={styles.closeButton}
          ></div>
          <div className={styles.progressBar}>
            <div
              ref={progressRef}
              className={`${styles.progressFill} ${
                type === 'Error'
                  ? styles.progressError
                  : type === 'Warning'
                    ? styles.progressWarning
                    : styles.progressSuccess
              }`}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default Notification;
